import Vue from 'vue';
import axios from 'axios';
import '../../../../filters';
import moment from 'moment';
import { validationMixin } from 'vuelidate';
import { required, email, minLength, maxLength, minValue } from 'vuelidate/lib/validators';
import users from '../../../../users';

export default {
  name: 'issueCharges',
  mixins: [users, validationMixin],
  components: {
    TreeSelect: require('../../../../customcontrols/selectOfTree.vue').default
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      readOnly: false,
      bankGuaranteeDataLoaded: false,
      bankGuaranteeData: {
        gBank: '',
        gRef: '',
        gTermination: null,
        gAmount: 0,
        gComments: ''
      },
      gTermination2: null,
      gBanks: [],


      lang: '',
      hasCollectDeposit: false,
      isIssueCharges: false,
      //anyInstallments: false,
      //readOnly: false,

      collectDepositData: {
        deposit: '',
        depositAmount: 0,
        hasBankGuarantee: false
      },

      feesData: {
        customChargeDate: null,
        code: '',
        fees: [],
        hasCustomChargeDate: false,
        hasInstallmentsChecked: false,
        hasInstallmentsVisible: false
      },
      customChargeDateView: null,

      selectedFeesCode: [],
      totalFee: 0,
      
      
      
      installmentsData: {
        totalAmount: 0,
        installmentMethod: '',
        installmentMethods: [],
        installmentAmount: 0,
        numberOfInstallments: 0,
        initialAmount: 0,
        chargeSchedule: '',
        chargeSchedules: [],
        chargeMonth: 0,
        chargeDay: 0,
        installments: []
      },
      installmentsCols: [],

      depositCode: '',

      feesModel: [],

      selectFee: {
        mainItem: null,
        subItem: '0',
        actualCost: 0,
        numberOfUnits: 1
      },

      currentTab: 'tab-charges',
      installmentDescribe: '',
      selectedPenaltyType: 0,
      selectedPenaltyValue: 0,
      installmentsPenaltyValues: [],
    }
  },
  validations: {
    //depositCode: {
    //  required
    //},
    totalFee: {
      minValue: minValue(0.01)
    },
    dataObj: {
      guaranteeData: {
        gAmount: {
          required,
          minValue: minValue(0.01)
        },
        gBank: {
          required,
          minValue: minValue(1)
        },
        gRef: {
          required
        }
      },
      installmentsData: {
        installmentAmount: {
          required,
          minValue: minValue(0.01)
        },
        numberOfInstallments: {
          required,
          minValue: minValue(1)
        },
        initialAmount: {
          required,
          minValue: minValue(0)
        },
        chargeMonth: {
          required,
          minValue: minValue(1)
        },
        chargeDay: {
          required,
          minValue: minValue(1)
        },
        penaltyValue: {
          minValue: minValue(0)
        }
      }
    },
    selectFee: {
      mainItem: {
        required,
        minValue: minValue(0)
      },
      subItem: {
        required
      },
      actualCost: {
        required,
        minValue: minValue(0.01)
      },
      numberOfUnits: {
        required,
        minValue: minValue(1)
      }
    }
  },
  computed: {
    selectedMainItem() {
      return this.selectFee.mainItem;
    },
    selectedSubItem() {
      return this.selectFee.subItem;
    },
    //initialAmount() {
    //  return this.dataObj.installmentsData.initialAmount;
    //}
  },
  watch: {
    customChargeDateView: function (val) {
      this.dataObj.feesData.customChargeDate = moment(val, "DD/MM/YYYY").add(1, 'days');
    },
    gTermination2: function (val) {
      this.guaranteeData.gTermination = moment(val, "DD/MM/YYYY").add(1, 'days');
    },
    selectedMainItem() {
      if (this.selectFee.mainItem == null)
        return;

      if (this.dataObj.feesList.length == 0) {
        this.selectFee.mainItem = null;
        this.selectFee.subItem = null;
        this.selectFee.actualCost = 0;
        this.selectFee.numberOfUnits = 1;

        return;
      }

      if (this.dataObj.feesList[this.selectFee.mainItem].fees.length == 0)
        this.selectFee.subItem = null;
      else {
        this.selectFee.subItem = this.dataObj.feesList[this.selectFee.mainItem].fees[0].id;
      }

      this.selectFee.actualCost = 0;
      this.selectFee.numberOfUnits = 1;
    },
    selectedSubItem() {
      this.selectFee.actualCost = 0;
      this.selectFee.numberOfUnits = 1;
    },
    //initialAmount() {
    //  this.dataObj.installmentsData.totalAmount = Number(this.totalFee.toFixed(2)) - this.dataObj.installmentsData.initialAmount;
    //}
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('issue_charges_updated', this.init);
    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        //console.log('this.dataObj', this.dataObj);
        this.selectFee.mainItem = null;

        this.dataObj.feesData.feesList = [];
        this.prepareInstallments();

        //if (this.dataObj.appKey == 0)
        //  this.addFixedCharges();
        //else
        this.addSelectedCharges();

        this.appId = this.dataObj.appId;
        this.depositCode = this.dataObj.collectDepositData == null ? '' : (this.dataObj.collectDepositData.deposit == null ? '' : this.dataObj.collectDepositData.deposit.code);

        this.readOnly = this.dataObj.readOnly;

        if (this.dataObj.hasCollectDeposit) {
          Vue.delete(this.dataObj.collectDepositData, 'deposits');
        }

        this.customChargeDateView = moment(this.dataObj.feesData.customChargeDate).format('DD/MM/YYYY');

        //if (this.dataObj.isIssueCharges) {
        //  for (var i = 0; i < this.dataObj.feesData.feesList.length; i++) {
        //    if (this.dataObj.feesData.feesList[i].fees.filter(a => a.selected == true).length > 0)
        //      this.feesModel.push({
        //        code: i + '_' + this.dataObj.feesData.feesList[i].fees.filter(a => a.selected == true)[0].code,
        //        netAmount: 0,
        //        actualCost: this.dataObj.feesData.feesList[i].fees.filter(a => a.selected == true)[0].actualCost
        //      });
        //    else
        //      this.feesModel.push({
        //        code: i + '_',
        //        netAmount: 0,
        //        actualCost: 0
        //      });
        //  }

        //  this.calcTotalFee();
        //}

        if (this.guaranteeData != null)
          this.gTermination2 = moment(this.guaranteeData.gTermination).format('DD/MM/YYYY');

        //this.hasCollectDeposit = this.dataObj.hasCollectDeposit;
        //this.isIssueCharges = this.dataObj.isIssueCharges;
        ////this.anyInstallments = this.dataObj.anyInstallments;
        //this.readOnly = this.dataObj.readOnly;
        ////this.feesData = this.dataObj.feesData;
        ////this.collectDepositData = this.dataObj.collectDepositData;

        //console.log(this.dataObj);

        //if (this.hasCollectDeposit)
        //  this.fillDepositData(this.dataObj.collectDepositData);

        //if (this.isIssueCharges)
        //  this.fillFeesData(this.dataObj.feesData);

        //if (this.anyInstallments) {
        //  this.fillInstallmentsCols();
        //  this.getInstallmentsData();
        //}
      });
    },
    showDepositAmount() {
      if (this.collectDepositData.deposit == null)
        return false;

      return this.dataObj.deposits.filter(a => a.code == this.dataObj.collectDepositData.deposit).length == 0 ? false : this.dataObj.deposits.filter(a => a.code == this.dataObj.collectDepositData.deposit)[0].isActual;
    },
    setSelectedFees(val) {
      var idx = val.split('_')[0];
      var code = val.split('_')[1];

      for (var i = 0; i < this.dataObj.feesData.feesList[idx].fees.length; i++) {
        this.dataObj.feesData.feesList[idx].fees[i].selected = false;
      }

      this.dataObj.feesData.feesList[idx].fees.filter(a => a.code == code)[0].selected = true;
      this.feesModel[idx].actualCost = this.dataObj.feesData.feesList[idx].fees.filter(a => a.code == code)[0].rate;

      this.calcTotalFee();
    },
    setSelectedDeposits(code) {
      for (var i = 0; i < this.dataObj.deposits.length; i++) {
        this.dataObj.deposits.selected = false;
      }

      //console.log('code', code);
      //console.log('this.dataObj.deposits', this.dataObj.deposits);
      //console.log('this.dataObj.deposits.filter(a => a.code == code)[0]', this.dataObj.deposits.filter(a => a.code == code));

      this.dataObj.deposits.filter(a => a.code == code)[0].selected = true;
      this.dataObj.collectDepositData.deposit = this.dataObj.deposits.filter(a => a.code == code)[0];
      this.depositCode = this.dataObj.collectDepositData.deposit.code;
    },
    calcTotalFee() {
      var tot = 0;

      var rate = 0;
      var noUnits = 0;
      var netAmount = 0;

      for (var i = 0; i < this.dataObj.feesData.feesList.length; i++) {
        if (this.dataObj.feesData.feesList[i].fees.filter(a => a.selected).length > 0) {
          rate = this.dataObj.feesData.feesList[i].fees.filter(a => a.selected)[0].canModifyActualCost ? (this.feesModel[i].actualCost == '' ? 0 :
            Number(this.feesModel[i].actualCost)) : Number(this.dataObj.feesData.feesList[i].fees.filter(a => a.selected)[0].rate);

          noUnits = this.dataObj.feesData.feesList[i].fees.filter(a => a.selected)[0].isChargePerUnit == false ? 1 :
            (
              this.dataObj.feesData.feesList[i].fees.filter(a => a.selected)[0].numberOfUnits == '' ? 0 :
                (Number(this.dataObj.feesData.feesList[i].fees.filter(a => a.selected)[0].numberOfUnits) <= 0 ? 0 :
                  Number(this.dataObj.feesData.feesList[i].fees.filter(a => a.selected)[0].numberOfUnits)
                )
            );

          netAmount = Number((rate * noUnits).toFixed(2));
          this.feesModel[i].netAmount = netAmount;

          this.dataObj.feesData.feesList[i].fees.filter(a => a.selected)[0].vat = Number((netAmount * this.dataObj.feesData.feesList[i].fees.filter(a => a.selected)[0].vatRates.vatRate / 100).toFixed(2));
          this.dataObj.feesData.feesList[i].fees.filter(a => a.selected)[0].adminAmount = Number((netAmount * this.dataObj.feesData.feesList[i].fees.filter(a => a.selected)[0].vatRates.adminRate / 100).toFixed(2));
          this.dataObj.feesData.feesList[i].fees.filter(a => a.selected)[0].adminVatAmount = Number((this.dataObj.feesData.feesList[i].fees.filter(a => a.selected)[0].adminAmount * this.dataObj.feesData.feesList[i].fees.filter(a => a.selected)[0].vatRates.adminVatRate / 100).toFixed(2));
          this.dataObj.feesData.feesList[i].fees.filter(a => a.selected)[0].totalCost =
            Number((netAmount +
              this.dataObj.feesData.feesList[i].fees.filter(a => a.selected)[0].vat +
              this.dataObj.feesData.feesList[i].fees.filter(a => a.selected)[0].adminAmount +
              this.dataObj.feesData.feesList[i].fees.filter(a => a.selected)[0].adminVatAmount).toFixed(2));

          this.dataObj.feesData.feesList[i].fees.filter(a => a.selected)[0].actualCost = netAmount;

          tot += this.dataObj.feesData.feesList[i].fees.filter(a => a.selected)[0].totalCost;
        }
      }

      this.dataObj.installmentsData.totalAmount = Number(tot.toFixed(2));
      this.totalFee = Number(tot.toFixed(2));
    },
    setGuaranteeData() {
      this.bankGuaranteeData.gTermination = moment(this.gTermination2, "DD/MM/YYYY").add(1, 'days');

      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Item: JSON.parse(JSON.stringify(this.bankGuaranteeData))
      };

      return axios.post('/IssueChargesActivity/SetGuaranteeData', parameter)
        .then(response => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('messages.SetBankGuaranteeDataSuccess'), 2);
            return true;
          }
          else {
            this.$alertMsg(this.$t('messages.SetBankGuaranteeDataFailure'));
            return false;
          }
        })
        .catch(error => {
          this.$alertMsg(error.response.data);
          return false;
        });
    },
    setDepositData() {
      //console.log(this.dataObj.collectDepositData);
      //this.dataObj.collectDepositData.deposit = this.dataObj.deposits.filter(a => a.selected == true)[0];

      var parameters = {
        ApplicationId: Number(this.appId),
        ApplicationKey: 0,
        Item: JSON.parse(JSON.stringify(this.dataObj.collectDepositData))
      };

      //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      return axios.post('/IssueChargesActivity/SetDepositData', parameters)
        .then(response => {
          if (response.status == 200) {
            //this.$alertMsg(this.$t('messages.SetDepositsDataSuccess'), 2);
            //loader.hide();
            return true;
          }
          else {
            this.$alertMsg(this.$t('messages.SetDepositsDataFailure'));
            //this.$alertMsg(this.$t('messages.SetDepositsDataFailure'));
            //loader.hide();
            return false;
          }
        })
        .catch(error => {
          this.$alertMsg(error.response.data);
          //loader.hide();
          return false;
        });
    },
    setFeesData() {
      this.feesData.customChargeDate = moment(this.customChargeDate2, "DD/MM/YYYY").add(1, 'days');

      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Item: JSON.parse(JSON.stringify(this.dataObj.feesData))
      };

      //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      return axios.post('/IssueChargesActivity/SetFeesData', parameter)
        .then(response => {
          if (response.status == 200) {
            //this.$alertMsg(this.$t('messages.SetFeesDataSuccess'), 2);
            //loader.hide();
            return true;
          }
          else {
            this.$alertMsg(this.$t('messages.SetFeesDataFailure'));
            //this.$alertMsg(this.$t('messages.SetFeesDataFailure'));
            //loader.hide();
            return false;
          }
        })
        .catch(error => {
          this.$alertMsg(error.response.data);
          //loader.hide();
          return false;
        });
    },
    fillDepositData(data) {
      this.dataObj.collectDepositData = {
        deposit: null,
        depositAmount: data.depositAmount,
        hasBankGuarantee: data.hasBankGuarantee
      };

      this.deposits = data.deposits;
    },
    fillFeesData(data) {
      this.dataObj.feesData = data;

      this.feesData = this.dataObj.feesData;
      this.customChargeDateView = moment(this.feesData.customChargeDate).format('DD/MM/YYYY');
    },
    getDepositData() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0
      };
      axios.post('/IssueChargesActivity/GetDepositData', parameter)
        .then(response => {
          if (response.status == 200) {

            this.dataObj.collectDepositData = {
              deposit: null,
              depositAmount: response.data.item.depositAmount,
              hasBankGuarantee: response.data.item.hasBankGuarantee
            };

            //this.collectDepositData = response.data.item;
            this.deposits = response.data.item.deposits;
          }
        })
        .catch(error => {
          this.$alertMsg(error.response.data);
        });
    },
    getFeesData() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0
      };
      axios.post('/IssueChargesActivity/GetFeesData', parameter)
        .then(response => {
          if (response.status == 200) {
            this.dataObj.feesData = response.data.item;


            this.feesData = this.dataObj.feesData;
            this.customChargeDateView = moment(this.feesData.customChargeDate).format('DD/MM/YYYY');

            //for (var i = 0; i < this.feesData.fees.length; i++) {
            //  var a = {
            //    idx: i,
            //    code: this.feesData.fees[i].filter(a => a.selected).length == 0 ? 0 : this.feesData.fees[i].filter(a => a.selected)[0].code
            //  }

            //  this.selectedFeesCode.push(a);
            //}
          }
        })
        .catch(error => {
          this.$alertMsg(error.response.data);
        });
    },
    getInstallmentsData() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        TotalAmount: 0
      };
      axios.post('/IssueChargesActivity/GetInstallmentsData', parameter)
        .then(response => {
          if (response.status == 200) {
            this.installmentsData = response.data.item;
          }
        })
        .catch(error => {
          this.$alertMsg(error.response.data);
        });
    },
    setInstallmentsData() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Item: JSON.parse(JSON.stringify(this.installmentsData))
      };

      let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      axios.post('/IssueChargesActivity/SetInstallmentsData', parameter)
        .then(response => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('messages.SetInstallmentsDataSuccess'), 2);
            loader.hide();
            return true;
          }
          else {
            this.$alertMsg(this.$t('messages.SetInstallmentsDataFailure'));
            loader.hide();
            return false;
          }
        })
        .catch(error => {
          loader.hide();
          this.$alertMsg(error.response.data);
          return false;
        });
    },
    refreshInstallments() {
      var parameter = {
        ApplicationId: this.dataObj.appId,
        ApplicationKey: this.dataObj.appKey,
        Item: JSON.parse(JSON.stringify(this.dataObj.installmentsData))
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/IssueChargesActivity/RefreshInstallments', parameter),
        response => {
          console.log('IssueChargesActivity/RefreshInstallments', response.data);
          if (response.status == 200) {
            this.selectedPenaltyType = JSON.parse(JSON.stringify(this.dataObj.installmentsData.penaltyType));
            this.selectedPenaltyValue = JSON.parse(JSON.stringify(this.dataObj.installmentsData.penaltyValue));

            this.dataObj.installmentsData.installments = response.data.items;
            this.installmentDescribe = this.dataObj.installmentsData.chargeSchedule == 1 ? 'cycleNo' : 'chargeDate';

            this.installmentsPenaltyValues = [];

            if (this.selectedPenaltyType != 0) {
              var pv = 0;
              for (var i = 0; i < this.dataObj.installmentsData.installments.length; i++) {
                if (this.selectedPenaltyType == 1) {
                  pv = Number((this.dataObj.installmentsData.installments[i].amount * this.selectedPenaltyValue / 100).toFixed(3));
                } else if (this.selectedPenaltyType == 2) {
                  pv = Number(this.selectedPenaltyValue);
                }

                this.installmentsPenaltyValues.push({
                  value: pv,
                  total: this.dataObj.installmentsData.installments[i].amount + pv
                });
              }
            }
          }
          else
            this.$alertMsg(response.data.data.text)
        },
        err => {
          this.$alertMsg(err.data);
        }
      );
    },
    saveData() {
      if (this.hasCollectDeposit)
        this.setDepositData();

      if (this.isIssueCharges)
        this.setFeesData();

      if (this.collectDepositData.hasBankGuarantee)
        this.setGuaranteeData();
    },
    fillInstallmentsCols() {
      this.statusChangesCols.push({ dataField: 'number', caption: this.$t('activities.number') });
      this.statusChangesCols.push({ dataField: 'amount', caption: this.$t('activities.amount') });
      this.statusChangesCols.push({ dataField: 'chargeDate', caption: this.$t('activities.chargeDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
    },
    getValidationClass(obj1, obj2, obj3) {
      let field = null;

      if (obj2 == '' && obj3 == '')
        field = this.$v[obj1];
      else if (obj3 == '')
        field = this.$v[obj1][obj2];
      else
        field = this.$v[obj1][obj2][obj3];

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    async validateAppData() {
      var depositCheck = true;
      var feesCheck = true;
      var installmentCheck = true;


      if (this.dataObj.isIssueCharges) {
        this.$v.totalFee.$touch();

        if (this.$v.totalFee.$invalid) {
          this.$alertMsg(this.$t('activities.SomeFeesAreNotSelected'), 3);
          //  feesCheck = false;
        }
      }

      if (this.dataObj.hasCollectDeposit) {
        this.$v.depositCode.$touch();

        if (this.dataObj.collectDepositData.hasBankGuarantee) {
          this.$v.dataObj.guaranteeData.$touch();
          if (!this.$v.depositCode.$invalid && !this.$v.dataObj.guaranteeData.$invalid)
            depositCheck = true;
          else
            depositCheck = false;
        }
        else {
          if (!this.$v.depositCode.$invalid)
            depositCheck = true;
          else
            depositCheck = false;
        }
      }

      if (this.dataObj.feesData.hasInstallmentsChecked) {
        if (this.dataObj.installmentsData.installmentMethod == 0) {
          this.$v.dataObj.installmentsData.installmentAmount.$touch();

          if (this.$v.dataObj.installmentsData.installmentAmount.$invalid)
            installmentCheck = false;
        }
        else if (this.dataObj.installmentsData.installmentMethod == 1) {
          this.$v.dataObj.installmentsData.numberOfInstallments.$touch();

          if (this.$v.dataObj.installmentsData.numberOfInstallments.$invalid)
            installmentCheck = false;
        }

        this.$v.dataObj.installmentsData.initialAmount.$touch();
        if (this.$v.dataObj.installmentsData.initialAmount.$invalid)
          installmentCheck = false;

        this.$v.dataObj.installmentsData.penaltyValue.$touch();
        if (this.$v.dataObj.installmentsData.penaltyValue.$invalid)
          installmentCheck = false;

        if (this.dataObj.installmentsData.chargeSchedule == 0) {
          this.$v.dataObj.installmentsData.chargeMonth.$touch();
          this.$v.dataObj.installmentsData.chargeDay.$touch();

          if (this.$v.dataObj.installmentsData.chargeMonth.$invalid || this.$v.dataObj.installmentsData.chargeDay.$invalid)
            installmentCheck = false;
        }
      }

      if (depositCheck && installmentCheck)
        return true;
      else
        return false;
    },
    deSelect(index) {
      for (var i = 0; i < this.dataObj.feesData.feesList[index].fees.length; i++) {
        this.dataObj.feesData.feesList[index].fees[i].selected = false;
      }

      this.feesModel[index] = index + '_';
      this.calcTotalFee();
    },
    addFee() {
      if (this.selectFee.mainItem == null || this.selectFee.subItem == null)
        return;

      var fee = this.dataObj.feesList[this.selectFee.mainItem].fees.filter(a => a.id == this.selectFee.subItem)[0];

      //console.log('fee', fee);
      console.log('this.selectFee', this.selectFee);

      this.$v.selectFee.mainItem.$touch();
      this.$v.selectFee.subItem.$touch();

      if (fee.canModifyActualCost)
        this.$v.selectFee.actualCost.$touch();

      if (fee.isChargePerUnit)
        this.$v.selectFee.numberOfUnits.$touch();

      if (this.$v.selectFee.mainItem.$invalid || this.$v.selectFee.subItem.$invalid
        || (fee.canModifyActualCost && this.$v.selectFee.actualCost.$invalid)
        || (fee.isChargePerUnit && this.$v.selectFee.numberOfUnits.$invalid))
        return;

      if (!this.addFeeValidation())
        return;

      var cost = 0;
      var netAmount = 0;

      //fee.actualCost = Number((this.dataObj.feesList[this.selectFee.mainItem].fees.filter(a => a.code == this.selectFee.subItem)[0].rate).toFixed(2));

      if (fee.canModifyActualCost) {
        cost = Number(Number(this.selectFee.actualCost).toFixed(2));
      }
      else {
        cost = Number((this.dataObj.feesList[this.selectFee.mainItem].fees.filter(a => a.code == this.selectFee.subItem)[0].rate).toFixed(2));
      }

      if (fee.isChargePerUnit) {
        fee.numberOfUnits = fee.isChargePerUnit ? Number(this.selectFee.numberOfUnits) : null;
        netAmount = fee.rate * fee.numberOfUnits;

        //fee.actualCost = netAmount;
      }
      else
        netAmount = cost;

      fee.vat = Number((netAmount * (fee.vatRates.vatRate / 100)).toFixed(2));
      fee.adminAmount = Number((netAmount * (fee.vatRates.adminRate / 100)).toFixed(2));
      fee.adminVatAmount = Number((fee.adminAmount * (fee.vatRates.adminVatRate / 100)).toFixed(2));
      fee.actualCost = netAmount + fee.vat;

      fee.selected = true;

      console.log('netAmount', netAmount);

      this.dataObj.feesTotals.push({
        index: this.selectFee.mainItem,
        code: this.selectFee.subItem,
        cost: cost.toFixed(2),
        netAmount: netAmount.toFixed(2),
        totalAmount: fee.isOnlyAdminFees ?
          (fee.adminAmount + fee.adminVatAmount).toFixed(2) :
          (netAmount + fee.vat + fee.adminAmount + fee.adminVatAmount).toFixed(2)
      });

      this.dataObj.feesData.feesList.push({
        description: this.dataObj.feesList[this.selectFee.mainItem].description,
        fees: new Array(fee),
        isFixedCharges: this.dataObj.feesList[this.selectFee.mainItem].isFixedCharges
      });

      this.calcTotal();
      //this.selectFee.mainItem = null;
      //this.selectFee.subItem = null;
      this.$v.selectFee.mainItem.$reset();
      this.$v.selectFee.subItem.$reset();
    },
    removeFee(index) {
      this.dataObj.feesData.feesList.splice(index, 1);
      this.dataObj.feesTotals.splice(index, 1);

      this.calcTotal();
    },
    calcTotal() {
      var total = 0;

      for (var i = 0; i < this.dataObj.feesTotals.length; i++) {
        total += Number(this.dataObj.feesTotals[i].totalAmount)
      }

      //total = Number(total.toFixed(2));

      this.totalFee = Number(total.toFixed(2));
      this.dataObj.installmentsData.totalAmount = Number(total.toFixed(2));
    },
    addFeeValidation() {
      for (var i = 0; i < this.dataObj.feesData.feesList.length; i++) {
        if (this.selectFee.subItem == this.dataObj.feesData.feesList[i].fees[0].code &&
          this.dataObj.feesData.feesList[i].fees[0].transCode == this.dataObj.feesList[this.selectFee.mainItem].fees[0].transCode &&
          this.dataObj.feesData.feesList[i].fees[0].transSubCode == this.dataObj.feesList[this.selectFee.mainItem].fees[0].transSubCode) {
          this.$alertMsg(this.$t('activities.feeAlreadyExists'));
          return false;
        }
      }

      return true;
    },
    addFixedCharges() {
      var fixedFees = this.dataObj.feesList.filter(a => a.isFixedCharges);

      for (var i = 0; i < fixedFees.length; i++) {
        fixedFees[i].fees[0].vat = Number((fixedFees[i].fees[0].actualCost * (fixedFees[i].fees[0].vatRates.vatRate / 100)).toFixed(2));
        fixedFees[i].fees[0].adminAmount = Number((fixedFees[i].fees[0].actualCost * (fixedFees[i].fees[0].vatRates.adminRate / 100)).toFixed(2));
        fixedFees[i].fees[0].adminVatAmount = Number((fixedFees[i].fees[0].adminAmount * (fixedFees[i].fees[0].vatRates.adminVatRate / 100)).toFixed(2));
        fixedFees[i].fees[0].selected = true;

        this.dataObj.feesTotals.push({
          index: i,
          code: fixedFees[i].fees[0].code,
          cost: fixedFees[i].fees[0].actualCost,
          netAmount: fixedFees[i].fees[0].actualCost,
          totalAmount: fixedFees[i].fees[0].isOnlyAdminFees ?
            (fixedFees[i].fees[0].adminAmount + fixedFees[i].fees[0].adminVatAmount).toFixed(2) :
            (fixedFees[i].fees[0].actualCost + fixedFees[i].fees[0].vat + fixedFees[i].fees[0].adminAmount + fixedFees[i].fees[0].adminVatAmount).toFixed(2)
        });

        this.dataObj.feesData.feesList.push({
          description: fixedFees[i].description,
          fees: new Array(fixedFees[i].fees[0]),
          isFixedCharges: fixedFees[i].isFixedCharges
        });
      }
    },
    addSelectedCharges() {
      for (var m = 0; m < this.dataObj.feesList.length; m++) {
        for (var f = 0; f < this.dataObj.feesList[m].fees.length; f++) {
          if (this.dataObj.feesList[m].fees[f].selected) {

            this.dataObj.feesTotals.push({
              index: f,
              code: this.dataObj.feesList[m].fees[f].code,
              cost: this.dataObj.feesList[m].fees[f].rate,
              netAmount: this.dataObj.feesList[m].fees[f].isChargePerUnit ? this.dataObj.feesList[m].fees[f].rate * this.dataObj.feesList[m].fees[f].numberOfUnits : this.dataObj.feesList[m].fees[f].rate,
              totalAmount: this.dataObj.feesList[m].fees[f].isOnlyAdminFees ?
                (this.dataObj.feesList[m].fees[f].adminAmount + this.dataObj.feesList[m].fees[f].adminVatAmount).toFixed(2) :
                (this.dataObj.feesList[m].fees[f].actualCost + this.dataObj.feesList[m].fees[f].adminAmount + this.dataObj.feesList[m].fees[f].adminVatAmount).toFixed(2)
            });

            this.dataObj.feesData.feesList.push({
              description: this.dataObj.feesList[m].description,
              fees: new Array(this.dataObj.feesList[m].fees[f]),
              isFixedCharges: this.dataObj.feesList[m].isFixedCharges
            });
          }
        }
      }

      this.calcTotal();
    },
    manageSingleSelectionSubFee(fee) {
      if (fee.isFixedCharges)
        return true;

      if (fee.fees[0].isSingleSelection) {
        for (var i = 0; i < this.dataObj.feesData.feesList.length; i++) {
          if (this.dataObj.feesData.feesList[i].fees[0].displayCode == fee.fees[0].displayCode) {
            return true;
          }
        }
      }

      return false;
    },
    changeTab(e) {
      this.currentTab = e;
    },
    prepareInstallments() {
      if (this.dataObj.installmentsData == null)
        return;

      if (this.dataObj.installmentsData.installments.length == 0)
        return;

      this.selectedPenaltyType = JSON.parse(JSON.stringify(this.dataObj.installmentsData.penaltyType));
      this.selectedPenaltyValue = JSON.parse(JSON.stringify(this.dataObj.installmentsData.penaltyValue));

      this.installmentDescribe = this.dataObj.installmentsData.chargeSchedule == 1 ? 'cycleNo' : 'chargeDate';

      this.installmentsPenaltyValues = [];

      if (this.selectedPenaltyType != 0) {
        var pv = 0;
        for (var i = 0; i < this.dataObj.installmentsData.installments.length; i++) {
          if (this.selectedPenaltyType == 1) {
            pv = Number((this.dataObj.installmentsData.installments[i].amount * this.selectedPenaltyValue / 100).toFixed(3));
          } else if (this.selectedPenaltyType == 2) {
            pv = Number(this.selectedPenaltyValue);
          }

          this.installmentsPenaltyValues.push({
            value: pv,
            total: this.dataObj.installmentsData.installments[i].amount + pv
          });
        }
      }
    }
  },
}

